import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, filter, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AuthActions } from '@store/actions/auth/auth.actions';
import { AuthService } from '@services/auth.service';
import { IdleActions } from '@store/actions/idle/idle.actions';
import { UserActions } from '@store/actions/user/user.actions';
import { ErrorDialogService } from '@services/error-dialog.service';

@Injectable()
export class AuthEffects {

  setActiveAccount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.redirectEnd),
      filter(() => this.authService.isAuthenticated()),
      switchMap(() => {
        return this.authService.setActiveAccount().pipe(
          map(data => AuthActions.setActiveAccountSuccess({ account: data })),
          catchError(error => of(AuthActions.setActiveAccountFailure({ error })))
        );
      })
    )
  });

  getAuthorizationToken$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.setActiveAccountSuccess),
      switchMap((account: any) => {
        return this.authService.getAzureToken(account.account).pipe(
          map(data => AuthActions.getAzureTokenSuccess({ token: data })),
          catchError(error => of(AuthActions.getAzureTokenFailure({ error })))
        );
      })
    )
  });

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        UserActions.logoutButtonPressed,
        IdleActions.timedOut
      ),
      switchMap(() => {
        return this.authService.logout().pipe(
          map(() => AuthActions.logoutSuccess()),
          catchError(error => of(AuthActions.logoutFailure({ error })))
        );
      })
    )
  });

  loginError$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.loginError),
      tap((action) => {
        console.error('[AuthEffects] Login error:', action.error);
        
        this.errorDialogService.showOrganizationAccessDenied(action.error)
          .subscribe((confirmed) => {
            if (confirmed) {
              this.authService.logout().subscribe({
                next: () => console.log('[AuthEffects] Logout successful'),
                error: (error) => console.error('[AuthEffects] Logout failed:', error)
              });
            }
          });
      })
    );
  }, { dispatch: false });

  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private errorDialogService: ErrorDialogService
  ) {}
}